
import type { SVGProps } from 'react';
const SvgFleet = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#fleet_svg__a)">
      <path
        fill="#263E6A"
        d="M19.73 19.458c-1.05 0-1.865-.107-2.527-.275l1.821-4.894a.706.706 0 0 0-.422-.914l-.76-.273V9.588h.92a.27.27 0 0 0 .27-.271V8.03a.27.27 0 0 0-.27-.27h-1.587V6.014a.42.42 0 0 0-.417-.419h-3.316v-1.18A.415.415 0 0 0 13.028 4h-2.024a.415.415 0 0 0-.414.416v1.18H7.274a.42.42 0 0 0-.417.419v1.744H5.27A.27.27 0 0 0 5 8.03v1.287c0 .15.12.271.27.271h.92v3.523l-.792.286a.707.707 0 0 0-.423.915l1.782 4.815c-.685.2-1.49.33-2.487.33a.27.27 0 0 0 0 .543c2.497 0 3.856-.766 5.055-1.442.887-.5 1.653-.933 2.73-.933 1.121 0 1.72.393 2.48.89C15.542 19.178 16.796 20 19.73 20a.27.27 0 0 0 0-.542m-1.216-5.486c.019.04.02.086.005.128l-.311.835-5.931-2.1v-1.15q.03.008.057.017l6.086 2.183a.16.16 0 0 1 .094.087m-7.384-9.43h1.772v1.054H11.13zM7.396 6.138h9.24V7.76h-9.24zM5.54 8.301h12.952v.745H5.54zm1.19 1.287h10.572v3.32l-4.786-1.716a1.7 1.7 0 0 0-1.013 0L6.73 12.917zm-1.244 4.406a.17.17 0 0 1 .094-.087l6.106-2.204q.024-.008.052-.016v1.169L5.79 14.96l-.31-.839a.17.17 0 0 1 .005-.128m6.568 3.09c-1.217 0-2.08.486-2.993 1.001-.533.3-1.1.618-1.79.873L5.978 15.47l5.758-2.04-.001 1.863c0 .15.12.271.27.271a.27.27 0 0 0 .27-.27v-1.885l5.743 2.034-1.334 3.586c-.792-.27-1.342-.63-1.856-.967-.767-.504-1.492-.979-2.775-.979"
      />
    </g>
    <defs>
      <clipPath id="fleet_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFleet;
